
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.886 4.886a9 9 0 1112.728 12.728.75.75 0 01-1.06-1.06 7.5 7.5 0 10-10.607 0 .75.75 0 01-1.061 1.06 9 9 0 010-12.728z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.325 6.964h3.282a.75.75 0 110 1.5H9.3c-.02 0-.04 0-.06-.002a.556.556 0 00-.599.598l.003.06c0 .005.023.17.453.512.39.31.925.62 1.529.968l.03.018c.567.327 1.196.69 1.682 1.076.453.36 1.017.918 1.02 1.679a2.128 2.128 0 01-2.162 2.163H7.893a.75.75 0 010-1.5h3.322a.628.628 0 00.642-.642v-.014c0-.005-.023-.17-.453-.512-.39-.31-.925-.62-1.529-.968l-.03-.018c-.567-.327-1.196-.69-1.682-1.076-.448-.356-1.005-.906-1.02-1.655a2.056 2.056 0 012.182-2.187z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.25 5.196a.75.75 0 01.75.75v1.768a.75.75 0 01-1.5 0V5.946a.75.75 0 01.75-.75zM10.25 14.036a.75.75 0 01.75.75v1.768a.75.75 0 01-1.5 0v-1.768a.75.75 0 01.75-.75z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.25 16.5h17.5V18H1.25v-1.5z","fill":"currentColor"}})])
          )
        }
      }
    